import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { StorageV2Service, ToastV2Service } from '@schenck/rotec-components';
import { Tenant } from '../utils/models/tenant.model';
import { TenantApi } from 'src/api/tenant.api';
import { SpinnerService } from './spinner-service/spinner.service';

const serviceKey = 'Tenant';

@Injectable()
export class TenantService extends BaseService<Tenant> {
  constructor(
    protected storageService: StorageV2Service,
    protected tenantApi: TenantApi,
    protected toastService: ToastV2Service,
    protected spinnerService: SpinnerService
  ) {
    super(storageService, toastService, tenantApi, serviceKey, spinnerService);
    this.initGridState();
  }

  public getTenantNameById(tenantId: string): string {
    return this.results?.find(({ id }) => id === tenantId)?.name;
  }
}
